import {
  IntegrationsInfojobsValueTypeEnum,
  SuboptionValueOptionsDocument,
} from 'generated/resources/graphql'

import Select from 'modules/core/components/Select'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { INITIAL_ID_VALUE } from './utils'

interface SuboptionProps {
  label: string
  category: IntegrationsInfojobsValueTypeEnum
  companyId: number
  parentId: number
  suboptionId?: number
  error?: string | undefined
  onChange: (suboptionId: string) => void
}

export const SuboptionSelector = ({
  label,
  category,
  companyId,
  parentId,
  suboptionId,
  error,
  onChange,
}: SuboptionProps) => {
  const { loading, data } = useQuery(SuboptionValueOptionsDocument, {
    variables: {
      option: category,
      companyId: companyId,
      parentId: parentId.toString(),
    },
  })

  return (
    <Select
      label={label}
      options={
        data?.integrationsInfojobs?.valueOptionsConnection.nodes.map((suboption) => ({
          value: suboption?.value,
          label: suboption?.label,
        })) || []
      }
      none={i18n.t('common.select')}
      mandatory
      readonly={loading || parentId === INITIAL_ID_VALUE}
      onChange={onChange}
      error={error}
      value={suboptionId?.toString()}
    />
  )
}
